import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import { createFiltersSlice, type FiltersState } from "features/Application/slices/createFiltersSlice";

const initialState: FiltersState<number> = {
  filterOptions: {},
  appliedFilter: {},
  isLoading: false,
};

const groupFiltersSlice = createFiltersSlice({
  namePayload: {
    namespace: ReducerNamespaceTypes.People,
    entity: ReducerEntityPrefixTypes.Groups,
    name: "filtersOverviewOptions",
  },
  initialState,
  reducers: {},
});

export const { setSearch, setAppliedFilter, resetAppliedFilter, resetFilter } = groupFiltersSlice.actions;

export default groupFiltersSlice.reducer;
